<template>
  <div id="notesview">
        <notes v-bind:notes="notes"></notes>
        <create-note v-on:create-note="createNote"></create-note>
  </div>
</template>

<script>
import sweetalert from 'sweetalert';
import Notes from '@/components/Notes/Notes';
import CreateNote from '@/components/Notes/CreateNote';
export default {
  	name: 'Notesview',
  	props: ['car'],
	components: {
	    Notes,
	    CreateNote,
	},
  	data() {
	    return {
	      		notes: []
			  }
	},
	sockets: {
	    syncNotes( obj ) {
		    console.log( obj.notes );
		    if(obj.action == 'getAll') { console.log('getAll sync');	this.notes = obj.notes; }
		    if(obj.action == 'created') { console.log('created sync');	this.notes.push( obj.notes[0] ); }
    	},
    },  
	methods: {
	    createNote(newNote) {
 		   //console.log(newNote); 		    
	      //this.notes.push(newNote);
	      this.$socket.emit('syncNotes', { action: "create",  data: { vgn: this.car.vorgangsnummer, note: newNote.note } } );
	      //console.log(this.notes);
	      }
	},
	
	mounted: function(){
		//console.log('mounted')
		//console.log( this.car.vorgangsnummer );

		if(this.car.readby < 1) {		
			this.car.readby = 1;
			this.$socket.emit('updateCarR', { car: this.car, quiet: 1 } );
		}

		this.$socket.emit('syncNotes', {  action: "getAll", data: { vgn: this.car.vorgangsnummer } } );
	}
	
  
};
</script>